import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["refetch"];
import { useCallback, useMemo, useState } from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_PORTABLE_KEYS } from '../../data/queries';
import { captureException } from '../../utils/captureException';
export function usePortableKeys(options = {}) {
  const [portableKeyMap, setPortableKeyMap] = useState({});
  const _useQuery = useQuery(GET_PORTABLE_KEYS, Object.assign({}, options, {
      skip: true,
      onError: error => {
        var _options$onError;
        captureException(error, ['usePortableKeys']);
        (_options$onError = options.onError) === null || _options$onError === void 0 || _options$onError.call(options, error);
      },
      onCompleted: ({
        portableKeys
      }) => {
        var _options$onCompleted;
        setPortableKeyMap(portableKeys.assetIdsToPortableKeys);
        (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 || _options$onCompleted.call(options, {
          portableKeys
        });
      }
    })),
    {
      refetch
    } = _useQuery,
    portableKeysQuery = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  const fetchPortableKeys = useCallback(async () => {
    const response = await refetch();
    if (!response.data) {
      return [];
    }
    const {
      assetIdsToPortableKeys
    } = response.data.portableKeys;
    return Object.values(assetIdsToPortableKeys);
  }, [refetch]);
  const allPortableKeys = useMemo(() => {
    return Object.values(portableKeyMap);
  }, [portableKeyMap]);
  return Object.assign({
    allPortableKeys,
    fetchPortableKeys,
    portableKeyMap
  }, portableKeysQuery);
}